import { InitCookie } from '@patsnap/init-cookie';

export const useVisitorCookies = () => {
  function checkIfHome() {
    const url = new URL(window.location.href);

    const pathname = url.pathname; // "/mse/"
    const hash = url.hash; // "#/home"

    if (pathname === '/mse/' && hash.startsWith('#/home')) {
      return true;
    }

    return false;
  }

  function getEntryChannel() {
    const entryChannel = checkIfHome() ? 'mse_home' : 'mse_detail_page';
    return entryChannel;
  }

  async function init() {
    const entry_channel = getEntryChannel();
    if (entry_channel) {
      const cookie = new InitCookie({
        entry_channel,
      });
      return await cookie.init();
    }
  }

  return {
    init,
  };
};
